var DiscountsService = /** @class */ (function () {
    function DiscountsService(api) {
        var _this = this;
        this.listDiscounts = function () {
            var url = "/discount";
            return _this.API.get(url);
        };
        this.getDiscounts = function (discountId) {
            var url = "/discount/".concat(discountId);
            return _this.API.get(url);
        };
        this.createDiscount = function (discount) {
            var value = {
                discount: {
                    type: discount.type,
                    name: discount.name,
                    duration: discount.duration.toLowerCase(),
                    duration_in_months: discount.duration_in_months,
                    redeem_by: discount.redeem_by,
                    max_redemptions: Number(discount.max_redemptions),
                    amount_off: Number(discount.cost[0].key) * 100,
                    percentage_off: Number(discount.percentage_off),
                    currency: discount.cost[0].type,
                },
                bundles: discount.selectedBundles,
            };
            var url = "/discount";
            return _this.API.post(url, value);
        };
        this.updateDiscount = function (discountId, discount) {
            var value = {
                discount: {
                    name: discount.name,
                },
            };
            var url = "/discount/".concat(discountId);
            return _this.API.patch(url, value);
        };
        this.deleteDiscount = function (discountId) { return _this.API.delete("/discount/".concat(discountId)); };
        this.getDeleteConfirmationDiscount = function (discountId) {
            var url = "/discount/".concat(discountId, "/delete");
            return _this.API.get(url);
        };
        this.API = api;
    }
    return DiscountsService;
}());
export { DiscountsService };
